import React from 'react'
import { Box, Fade, Grid, Typography } from '@mui/material'
import Image from 'next/image'
import { useTranslation } from 'next-i18next'
import getLocalizeImage from '@utils/getLocalizedImage'
import ResponsiveButton from '@components/ResponsiveButton'
import CreateAccountLayout from './CreateAccountLayout'

const instructions = [
  {
    title: 'register',
    subtitle: 'Sign_up_and_tell_us_more_about_your_school',
    image: 'register-build.png',
  },
  {
    title: 'set_up_your_dashboard',
    subtitle: 'Manage_registrations,_waiting_lists',
    image: 'register-dashboard.png',
  },
  {
    title: 'start_use_the_mobile_app',
    subtitle: 'Imagine_how_happy_parents_will_be_by_being_engaged',
    image: 'register-mobile.png',
  },
]
function InstructionsSection({ handleSkip }) {
  const { t } = useTranslation()
  const [active, setActive] = React.useState(0)
  const handleNext = () => {
    if (active < instructions.length - 1) setActive(active + 1)
    else handleSkip()
  }
  return (
    <CreateAccountLayout>
      {instructions.map(({ title, subtitle, image }, index) => (
        <Fade
          in={active === index}
          key={index}
          sx={{ display: active === index ? '' : 'none' }}
        >
          <Grid
            container
            spacing={3}
          >
            <Grid
              item
              xs={12}
            >
              <Box
                sx={{
                  maxHeight: 350,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <Image
                  priority={index === 0}
                  style={{ maxWidth: '100%', maxHeight: 350, objectFit: 'contain' }}
                  src={getLocalizeImage(image)}
                  alt={`${t(`register:instructions.${title}`)} image`}
                  width={1000}
                  height={350}
                />
              </Box>
            </Grid>
            <Grid
              item
              xs={12}
            >
              <Typography
                textAlign="center"
                variant="h5"
                fontWeight={700}
                sx={{ mb: 3 }}
                display="block"
              >
                {index + 1}. {t(`register:instructions.${title}`)}
              </Typography>
              <Typography
                textAlign="center"
                variant="body1"
                fontWeight={400}
                color="neutral.dark"
                display="block"
              >
                {t(`register:instructions.${subtitle}`)}
              </Typography>
            </Grid>
            <Grid
              item
              xs={12}
            >
              <Grid
                container
                spacing={2}
                justifyContent="center"
              >
                {instructions.map((a, idx) => (
                  <Grid
                    item
                    key={idx}
                  >
                    <Box
                      sx={{
                        backgroundColor: idx === active ? 'primary.main' : '#9E9E9E80',
                        borderRadius: '10px',
                        width: 30,
                        height: 10,
                      }}
                    />
                  </Grid>
                ))}
              </Grid>
            </Grid>
            <Grid
              item
              xs={12}
            >
              <Grid
                container
                spacing={2}
                justifyContent="space-between"
              >
                <Grid item>
                  <ResponsiveButton
                    id="instructions-skip-button"
                    color="neutral"
                    sx={{ color: 'neutral.dark' }}
                    onClick={handleSkip}
                    aria-label={t('common:skip')}
                  >
                    {t('common:skip')}
                  </ResponsiveButton>
                </Grid>
                <Grid item>
                  <ResponsiveButton
                    variant="contained"
                    sx={{ minWidth: 125 }}
                    onClick={handleNext}
                    disableElevation
                    aria-label={t('common:next')}
                  >
                    {t('common:next')}
                  </ResponsiveButton>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Fade>
      ))}
    </CreateAccountLayout>
  )
}

export default InstructionsSection
